import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ArrowLeft } from 'lucide-react';

interface PreviewProps {
  content: string;
  onBack: () => void;
}

export const Preview: React.FC<PreviewProps> = ({ content, onBack }) => {
  return (
    <div className="min-h-screen bg-white">
      {/* Preview Header */}
      <div className="sticky top-0 z-30 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className="flex items-center justify-between max-w-4xl mx-auto px-6 py-4">
          <button
            onClick={onBack}
            className="inline-flex items-center text-slate-600 hover:text-slate-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Editor
          </button>
          <span className="text-xs inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-slate-100 text-slate-700 border border-slate-200">Preview</span>
        </div>
      </div>

      {/* Preview Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div
          className="prose prose-slate max-w-none
            prose-headings:font-semibold
            prose-h1:text-3xl prose-h1:mb-6 prose-h1:mt-8
            prose-h2:text-2xl prose-h2:mb-4 prose-h2:mt-6
            prose-h3:text-xl prose-h3:mb-3 prose-h3:mt-4
            prose-p:text-slate-700 prose-p:leading-relaxed prose-p:mb-4
            prose-strong:font-semibold prose-strong:text-slate-900
            prose-em:italic
            prose-ul:list-disc prose-ul:pl-6 prose-ul:mb-4
            prose-ol:list-decimal prose-ol:pl-6 prose-ol:mb-4
            prose-li:mb-2 prose-li:text-slate-700
            prose-code:bg-slate-100 prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:text-sm
            prose-pre:bg-slate-900 prose-pre:text-slate-100
            prose-blockquote:border-l-4 prose-blockquote:border-slate-300 prose-blockquote:pl-4 prose-blockquote:italic
            prose-hr:border-slate-200"
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};
